<ng-container *ngFor="let count of counter">
  <ax-icon
    class="icon"
    [ngClass]="{'is-active': (property.value | number) || 0 >= count}"
    name="star"
  ></ax-icon>
</ng-container>
